import { useState } from "react";

export default function SafeZoneTool() {
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [platform, setPlatform] = useState("instagram-story");
  const [size, setSize] = useState("medium");

  const platformOptions = ["instagram-story", "instagram-reel", "facebook-story", "facebook-reel", "tiktok", "youtube-shorts"];
  const sizeOptions = ["small", "medium", "large"];

  const sizeDescriptions = {
    small: "**Small:** Designed for lower-end devices and older phones. Examples: iPhone SE, budget Androids. Adjusted safe zones to account for limited screen space.",
    medium: "**Medium:** Optimized for most modern smartphones. Examples: iPhone 13/14, Pixel 6. Matches standard platform recommendations.",
    large: "**Large:** Ideal for high-resolution flagship devices. Examples: iPhone 15 Pro Max, Samsung S23 Ultra. Uses minimal safe zones as UI elements occupy less space.",
  };

  const safeZoneStyles = {
    "instagram-story": {
      small: { top: "16%", bottom: "22%", left: "5%", right: "5%" },
      medium: { top: "14%", bottom: "20%", left: "5%", right: "5%" },
      large: { top: "12%", bottom: "18%", left: "5%", right: "5%" },
    },
    "instagram-reel": {
      small: { top: "16%", bottom: "22%", left: "5%", right: "5%" },
      medium: { top: "14%", bottom: "20%", left: "5%", right: "5%" },
      large: { top: "12%", bottom: "18%", left: "5%", right: "5%" },
    },
    "facebook-story": {
      small: { top: "16%", bottom: "22%", left: "5%", right: "5%" },
      medium: { top: "14%", bottom: "20%", left: "5%", right: "5%" },
      large: { top: "12%", bottom: "18%", left: "5%", right: "5%" },
    },
    "tiktok": {
      small: { top: "16%", bottom: "37%", left: "8%", right: "8%" },
      medium: { top: "14%", bottom: "35%", left: "6%", right: "6%" },
      large: { top: "12%", bottom: "33%", left: "4%", right: "4%" },
    },
    "youtube-shorts": {
      small: { top: "17%", bottom: "37%", left: "6%", right: "6%" },
      medium: { top: "15%", bottom: "35%", left: "4%", right: "4%" },
      large: { top: "13%", bottom: "33%", left: "2%", right: "2%" },
    },
  };

  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(URL.createObjectURL(uploadedFile));
      setFileType(uploadedFile.type.startsWith("video/") ? "video" : "image");
    }
  };

  return (
    <div style={{ padding: "20px", textAlign: "center", backgroundColor: "black", color: "white" }}>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}>Safe Zone Overlay Tool</h1>

      <input type="file" accept="image/*,video/*" onChange={handleFileUpload} style={{ marginBottom: "20px" }} />

      <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid white", borderRadius: "5px" }}>
        <label style={{ fontWeight: "bold" }}>Select Platform:</label>
        <select value={platform} onChange={(e) => setPlatform(e.target.value)} style={{ marginLeft: "10px" }}>
          {platformOptions.map((option) => (
            <option key={option} value={option}>{option.replace("-", " ").toUpperCase()}</option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid white", borderRadius: "5px" }}>
        <label style={{ fontWeight: "bold" }}>Select Size:</label>
        <select value={size} onChange={(e) => setSize(e.target.value)} style={{ marginLeft: "10px" }}>
          {sizeOptions.map((option) => (
            <option key={option} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>
          ))}
        </select>
        <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#222", borderRadius: "5px", textAlign: "left" }}>
          <p style={{ fontWeight: "bold", marginBottom: "5px" }}>Size Description:</p>
          <p style={{ fontSize: "14px" }}>{sizeDescriptions[size]}</p>
        </div>
      </div>

      {file && (
        <div style={{ width: "100%", maxWidth: "500px", margin: "auto", position: "relative", border: "2px solid white" }}>
          {fileType === "video" ? (
            <video controls style={{ width: "100%", height: "auto" }}>
              <source src={file} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img src={file} alt="Uploaded Preview" style={{ width: "100%", height: "auto" }} />
          )}
          <div
            style={{
              position: "absolute",
              top: safeZoneStyles[platform][size].top,
              bottom: safeZoneStyles[platform][size].bottom,
              left: safeZoneStyles[platform][size].left,
              right: safeZoneStyles[platform][size].right,
              border: "4px solid red",
              opacity: 0.8,
              pointerEvents: "none",
            }}
          />
        </div>
      )}
    </div>
  );
}


